import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';

import { ViewPreference } from 'src/app/models';
import { AppStateService } from './app-state.service';

@Injectable({
  providedIn: 'root',
})
export class ViewPreferenceService {
  private preference: ViewPreference = {
    showEfficiency: true,
    showSlidingVelocity: true,
    showSpeed100VolumetricEfficiency: true,
    showTolerances: false,
    showNpshrLow: false,
    useImperialUnits: false,
  };

  private changeSubject = new Subject<ViewPreference>();

  preferencesChanged = this.changeSubject.asObservable();

  constructor(private appStateService: AppStateService) {
    appStateService
      .getState()
      .pipe(take(1))
      .subscribe((appState) => (this.preference = appState.viewPreference));
  }

  getPreference() {
    return this.preference;
  }

  setPreference(preference: ViewPreference) {
    this.preference = preference;

    this.appStateService.patchViewPreference(this.preference);

    this.changeSubject.next(this.preference);
  }
}
